import Model from '../Model'

export default class PurchaseOrder extends Model {

    getDownloadUrl() {
        return route('api.v2.external.purchase-order.pdf', [this.id]) + '?jwt=' + ((window.auth && window.auth.token) ? window.auth.token : '')
    }

}
